// v101.45.1 · Página propia del relleno de infraestructura de red (VLANs → IPs → relaciones VLAN↔equipo).
import Layout from "../components/Layout";
import InfraRefillCard from "../components/InfraRefillCard";

export default function InfraRedRelleno() {
  return (
    <Layout>
      <div className="space-y-4" data-testid="page-infra-red">
        <div>
          <h1 className="text-lg font-bold text-[#0A3747]">Infraestructura de red · VLANs / IPs / Relaciones</h1>
          <p className="text-xs text-gray-500">
            Compara Odoo con AlfaField y trae lo que falta. El relleno corre en el servidor; puede cerrar esta página.
          </p>
        </div>
        <InfraRefillCard />
      </div>
    </Layout>
  );
}
